import { VFC } from 'react'
import { appendStyleOverrides } from '@opallabs/lapidary/src/components/utils'
import { TextEditorInput } from '@opallabs/text-editor'
import { ContentTextInputProps } from './types'

export const ContentTextInput: VFC<ContentTextInputProps> = ({
  ariaLabel = 'Content Text',
  characterCounterOptions,
  characterLimit = null,
  forceLTR,
  highlightSocialTags,
  inputStyle,
  isSoftLimit = false,
  maxRows,
  minRows = 1,
  onChange,
  placeholder = 'Add content...',
  placeholderStyle,
  readOnly = false,
  rowHeight,
  style,
  textAlign,
  textIndent,
  truncate,
  truncationLimit = null,
  value = '',
}) => (
  <TextEditorInput
    ariaLabel={ariaLabel}
    characterLimit={{
      limit: characterLimit,
      isSoftLimit,
      ...characterCounterOptions,
    }}
    forceLTR={forceLTR}
    highlightSocialTags={highlightSocialTags}
    initialValue={value}
    maxRows={maxRows}
    minRows={minRows}
    onChange={onChange}
    placeholderText={placeholder}
    readOnly={readOnly}
    rowHeight={rowHeight}
    styleOverrides={{
      container: typeof style === 'function' ? style?.(readOnly) : style,
      content: [
        ...appendStyleOverrides(inputStyle),
        {
          'p:first-of-type': { textIndent },
          'p.is-editor-empty:first-of-type::before': placeholderStyle,
        },
      ],
    }}
    truncate={truncate}
    truncateOptions={{ limit: truncationLimit, ellipsis: true }}
    textAlign={textAlign}
  />
)
